<template>
  <div class="tickets">
    <div class="create">
      Create New Ticket
      <p class="plus">&plus;</p>
    </div>
    <div class="grid">
      <div class="ticket" v-for="(item) in tickets" :key="item.id">
        <h2>{{ item.name }}</h2>
        <p class="status">{{ item.status }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TciketsPage',
  components: {
  },
  props: {
  },
  data() {
    return {
      tickets: [
        { id: 0, name: "Screen Issue", status: "Open" },
        { id: 1, name: "Slow Computer", status: "Closed" },
        { id: 2, name: "Delete Profile", status: "Open" },
        { id: 3, name: "Factory Reset", status: "Ongoing" },
      ],
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style scoped>
.status {
  font-style: italic;
  font-weight: 800;
}

.ticket {
  width: 200px;
  height: 200px;
  background-color: transparent;
  border-radius: 1em;
  padding: 1em;
  margin: 0.7em;
  box-shadow: 1px 1px 11px 9px rgba(0, 0, 0, 0.12);
  -webkit-box-shadow: 1px 1px 11px 9px rgba(0, 0, 0, 0.12);
  -moz-box-shadow: 1px 1px 11px 9px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.plus {
  margin: 0;
  font-size: 30px;
}

.create {
  width: 200px;
  height: 200px;
  border-radius: 1em;
  padding: 1em;
  margin: 0.7em;
  margin-top: 3.7em;
  box-shadow: 1px 1px 11px 9px rgba(0, 0, 0, 0.12);
  -webkit-box-shadow: 1px 1px 11px 9px rgba(0, 0, 0, 0.12);
  -moz-box-shadow: 1px 1px 11px 9px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: rgb(81, 201, 131);
  color: white;
  font-weight: 600;
}

.tickets {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
}

.grid {
  margin-top: 3em;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  height: 132px;
}

</style>
